import { withFormsy } from 'formsy-react';
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

class DGRadioGroup extends Component {


    componentDidMount() {
        this.props.fields.forEach((field) => {
            if(field.value)
            {
                //values.push(field.fieldID.toString())
                this.props.setValue(field.fieldID.toString());
            }
        })
        // if(values.length)
        // {
        //     this.props.setValue(values);
        // }
    }

    childUpdated = (childValue) => {
        this.props.setValue(childValue);

    }

    changeValue = (event) => {

        this.props.setValue(event.currentTarget.value);

    }
    render() {

        const fields = this.props.fields;

        const childrenWithProps = React.Children.map(this.props.children, child => {
            // checking isValidElement is the safe way and avoids a typescript error too
            const props = { ...{ name: this.props.name, radio: true, childUpdated: this.childUpdated } };
            if (React.isValidElement(child)) {
                return React.cloneElement(child, props);
            }

            return child;
        });

        return (
            <>
                {/*<div className="ui grid">
                    {childrenWithProps.map(child => {
                        return <div className="eight wide column">{child}</div>
                    })}
                </div>*/}
                <Grid>
                    {
                        fields && fields.map((field, fieldIndex) => {
                            return (
                            field.isHidden ? "" :
                            <Grid.Column computer={16} mobile={16} tablet={16} key={`radiogroup-grid-column-${field.fieldID}`}>
                                <div className={`chkbox-field ${!this.props.isPristine && !this.props.isValid ? 'error' : ''}`} key={`chkbox-field-${field.fieldID}`}>
                                    <label className="checkbox" key={`chkbox-${field.fieldID}`} >

                                        <input onClick={() => this.props.onSelection && this.props.onSelection()} type="radio" checked={(this.props.value == field.fieldID.toString())} name={this.props.name} key={`chkbox-ctrl-${field.fieldID}`} onChange={this.changeValue} value={field.fieldID} />


                                        <span className="checkbox__icon" key={`chkbox-icon-${field.fieldID}`}></span>
                                        <span className="text" key={`chkbox-label-${field.fieldID}`}>{field.name}</span>
                                    </label>
                                </div>
                            </Grid.Column>)
                        })
                    }
                </Grid>

                {
                    !this.props.isPristine && !this.props.isValid &&
                    <div className="error error-checkbox-new" key={`chkbox-error-${this.props.name}`}>
                        {this.props.errorMessage}
                    </div>
                }
            </>
        );
    }
}

DGRadioGroup.propTypes = {
    // Parent props
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            fieldID: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]),
            name: PropTypes.string,
            value: PropTypes.any,
            isHidden: PropTypes.bool
        })
    ),

    children: PropTypes.node,
    name: PropTypes.string,
    errorMessage: PropTypes.string,
    onSelection: PropTypes.func,

    // Formsy injected props
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    setValue: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    isPristine: PropTypes.bool
}

export default withFormsy(DGRadioGroup)